import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Tariff_Import_Interface } from 'src/app/Interface/Tariff_Import_Interface';
import { Empty_Tariff_Interface, Tariff_Interface } from 'src/app/Interface/Tariff_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TariffService } from 'src/app/Service/Tariff/Tariff.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-TariffList',
  templateUrl: './TariffList.component.html',
  styleUrls: ['./TariffList.component.scss']
})
export class TariffListComponent implements OnInit {
  
  Filter_title:string=""
  Filter_dsc:string=""

  page:number=0;
  Procssing:boolean=false
  DeviceHasTarrif:number=0
  TarrifFloor:number=0
  modalRef_Delete: any;

  constructor(
    private Tariff_Service:TariffService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Tariff:Array<Tariff_Interface>=[]
  DataList_Tariff_Import:Array<Tariff_Import_Interface>=[]
  Data_Seleted_Delete:Tariff_Interface=Empty_Tariff_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(49).subscribe(
      data=>{
        this.ReadData_Tariff()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Tariff(){
    this.Procssing=true
    this.DeviceHasTarrif=0
    this.Tariff_Service.GetRecord(this.Filter_title,
      this.Filter_dsc).subscribe(
      data=>{
        this.DataList_Tariff=data['result']
        this.DataList_Tariff_Import=data['importTariff']
        this.DeviceHasTarrif=data['deviceCount']
        this.TarrifFloor=data['tarrifFloor']
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Delete(item:Tariff_Interface){
    this.modalRef_Delete.hide()
    this.Tariff_Service.DeleteTariff(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_Tariff()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  modalRef_Tariff: any;
  openModal_Tariff(template: TemplateRef<any>) {
    this.modalRef_Tariff = this.modalService.show(template);
  }

  Procssing_Import:boolean=false
  upload_file_excel(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import=true

    this.Tariff_Service.uploadFile(formData).subscribe(
      data=>{
        this.Procssing_Import=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.ReadData_Tariff()
        }
      }
    )

  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaTariff.xlsx");

  }

  exportexcel_Import(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table-import');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaTariff.xlsx");

  }


}
